import { zip, Subject } from 'rxjs'
import Metamask from './module/metamask'
import Header from './module/header'
import isMobile from 'is-mobile'
import { loadMemoriesPhase } from './util/memoriesPhaseLoader'
import MemoriesPhase1 from './module/memoriesPhase1'
import { abbrevAddr } from './util/string'
import { getExtension } from "./util/fragmentExtenstion";

class Memories {
    private metamask: Metamask
    private header: Header

    constructor() {
        const initializer = this.initialize
        const eventArray = Array.from(document.getElementsByTagName('div'))
            .filter((elem) => elem.getAttribute('include-html'))
            .map((elem) => {
                const file = elem.getAttribute('include-html')
                const eventEmitter = new Subject()
                fetch(file)
                    .then((response) => {
                        return response.text()
                    })
                    .then((html) => {
                        elem.insertAdjacentHTML('afterend', html)
                        elem.parentElement.removeChild(elem)
                        eventEmitter.next(true)
                    })
                    .catch((err) => {
                        console.error('error in fetching html', file, err)
                    })
                return eventEmitter
            })
        zip(eventArray).subscribe(() => {
            initializer()
        })
    }

    initialize = () => {
        this.header = new Header(null)
        this.metamask = this.header.metamask

        document.getElementById('fragmentClosePopup').onclick = () => {
            document.getElementById('fragmentPopup').classList.add('overlayHidden')
        }

        document.getElementById('openseaButtonPostSeason').onclick = () => {
            let url: string
            if (process.env.CHAIN_ID === '0x1')
                url = `https://opensea.io/collection/ghostsproject-fragments`
            else
                url = `https://testnets.opensea.io/collection/ghostsproject-fragments`
            window.open(url, "_blank")
        }

        document.getElementById('openseaButtonSpecialFragment').onclick = () => {
            let url: string
            if (process.env.CHAIN_ID === '0x1')
                url = `https://opensea.io/collection/special-fragment`
            else
                url = `https://testnets.opensea.io/collection/ghostsproject-special-fragment`
            window.open(url, "_blank")
        }

        // document.getElementById('roadmapBoxLink').onmouseover = () => {
        //     document.getElementById('roadmapHelpBox').classList.remove('hidden')
        // }
        // document.getElementById('roadmapBoxLink').onmouseleave = () => {
        //     document.getElementById('roadmapHelpBox').classList.add('hidden')
        // }

        const container = document.getElementById('fragmentsContainer')
        for (let idx = 1; idx <= 187; idx++) {
            const item = document.createElement('div')
            item.setAttribute('id', `fragment#${idx}`)
            const specialIdxs = [
                81, 82, 89, 95, 105,
                106, 107, 108, 139, 145,
                151, 158, 159, 163, 165,
                166, 167, 170, 172, 174,
                175, 181, 182, 183, 187
            ]
            if (specialIdxs.includes(idx)) {
                item.classList.add(`item-${idx}`)
            } else {
                item.classList.add('item-1x1')
            }
            const img = document.createElement('img')
            img.src = `${process.env.PUBLIC_S3_BUCKET}/FR_${("00" + idx).slice(-3)}_timg.${getExtension(idx, false)}`
            img.loading = 'lazy'
            item.appendChild(img)
            container.appendChild(item)
        }

        this.waitUntilMetamaskReady()
    }

    openMemoriesPhase = () => {
        zip(loadMemoriesPhase('memories_phase1.html')).subscribe(() => {
            new MemoriesPhase1(this.metamask)
        })
    }

    // openSpecialFragmentPhase = () => {
    //     zip(loadClaimPhase('claim_phase1.html')).subscribe(() => {
    //         new ClaimPhase1(this.metamask)
    //     })
    // }

    updateWeb3Info = () => {
        document.getElementById('misangImage').setAttribute('src', `${process.env.GHOST_BUCKET}/0.png`)

        if (document.getElementById('selectMemoriesPostSeason')) {
            document.getElementById('selectMemoriesPostSeason').onclick = (event) => {
                if (isMobile()) {
                    window.alert('Wallet connection is only supported on the PC. Please try again on the PC.')
                    return
                }
                if (this.metamask.account) {
                    document.getElementById('overlay').classList.remove('overlayHidden')
                    document.getElementById('memoriesSection').classList.add('noOverFlow')
                    this.openMemoriesPhase()
                } else {
                    this.header._connectWallet(event)
                }
            }
        }

        this.metamask.getMemoriesCount().then((counts: number[]) => {
            const [good, evil] = counts
            document.getElementById('memoriesCount').innerText = (good + evil).toString();
            const ratio = (Math.round(good / evil * 100) / 100).toString()
            document.getElementById('goodBarEnd').style.setProperty('flex-grow', ratio)
            if (good + evil > 0) {
                document.getElementById('goodProbEnd').innerText = `${Math.round(good / (good + evil) * 100)}%`
                document.getElementById('evilProbEnd').innerText = `${Math.round(evil / (good + evil) * 100)}%`
            }
        })

        this.metamask.getTokenIds().then((tokenIds: number[]) => {

            tokenIds.forEach((tokenId) => {
                const item = document.getElementById(`fragment#${tokenId}`)
                // const idText = document.createElement('div')
                // idText.setAttribute('id', `fragmentId#${tokenId}`)
                // idText.innerText = `#${tokenId}`
                // idText.classList.add('idText')
                // item.appendChild(idText)

                item.onclick = () => {
                    const wideTokens = [
                        108,
                        187,
                        81,
                        167,
                        89, 139, 145, 175
                    ]
                    if (wideTokens.includes(tokenId)) {
                        document.getElementById('fragmentPopupDashboard').classList.add('fragment-popup-wide')
                        document.getElementById('fragmentImageDiv').classList.add('fragment-image-wide')
                    } else {
                        document.getElementById('fragmentPopupDashboard').classList.remove('fragment-popup-wide')
                        document.getElementById('fragmentImageDiv').classList.remove('fragment-image-wide')
                    }

                    this.metamask.getFragmentOwner(tokenId).then((ownerAddress: string) => {
                        document.getElementById('fragmentOwnerAddress').innerText = abbrevAddr(ownerAddress)
                    })
                    document.getElementById('fragmentOwnerAddress').onclick = () => {
                        let url: string
                        if (process.env.CHAIN_ID === '0x1')
                            url = `https://opensea.io/assets/${process.env.FRAGMENT_ADDRESS}/${tokenId}`
                        else
                            url = `https://testnets.opensea.io/assets/${process.env.FRAGMENT_ADDRESS}/${tokenId}`
                        window.open(url, '_blank')
                    }
                    document.getElementById('fragmentTitle').innerText = `Fragment #${tokenId}`
                    const srcPath = `${process.env.PUBLIC_S3_BUCKET}/FR_${("00" + tokenId).slice(-3)}.${getExtension(tokenId, true)}`
                    if (getExtension(tokenId, true) === 'mp4') {
                        document.getElementById('fragmentImage').classList.add('hidden')
                        document.getElementById('fragmentVideo').classList.remove('hidden')
                        this.addMp4Video(document.getElementById('fragmentVideo'), srcPath)
                    } else {
                        document.getElementById('fragmentVideo').classList.add('hidden')
                        document.getElementById('fragmentImage').classList.remove('hidden')
                        document.getElementById('fragmentImage').setAttribute('src', "")
                        document.getElementById('fragmentImage').setAttribute('src', srcPath)
                    }
                    // document.getElementById('fragmentMemo').innerText = ""
                    document.getElementById('fragmentPopup').classList.remove('overlayHidden')
                }
            })
        })

    }

    waitUntilMetamaskReady = () => {
        if (!this.metamask.isReady) {
            window.setTimeout(this.waitUntilMetamaskReady, 100); /* this checks the flag every 100 milliseconds*/
        } else {
            this.updateWeb3Info()
            /* do something*/
        }
    }

    addMp4Video = (videoElm: any, srcPath: string) => {
        videoElm.pause();
        videoElm.srcObject = null;
        while (videoElm.firstChild) {
            videoElm.removeChild(videoElm.lastChild);
        }

        const source = document.createElement('source');
        source.setAttribute('src', srcPath);
        source.setAttribute('type', 'video/mp4');

        videoElm.appendChild(source);
        videoElm.play();
    }
}

new Memories()
